let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hrWRW")).then(() => parcelRequire('5eXCl'));